import React from 'react'
import { Link, graphql } from 'gatsby'

import {WebSubscribeForUpdates} from '@epi/epi-ui/es/websites'

import Environment from '../lib/Environment'
import Bio from '../components/Bio'
import Layout from '../components/Layout'
import SEO from '../components/seo'
import MakeNetSafe from '../components/MakeNetSafe'


class MakeTheNetSafePage extends React.Component {

    render () {
        const { data } = this.props
        const siteTitle = data.site.siteMetadata.title


        return (
            <Layout root={true} location={this.props.location} title={siteTitle}>
                <SEO
                siteName="Make The Net Safe"
                title="Make The Net Safe"
                />

                <div className="MakeTheNetSafePage">
                    <MakeNetSafe />
                </div>
            </Layout>
        )
    }
}

export default MakeTheNetSafePage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
